import Logo, { BrandText } from "./Logo";
import { useLang } from "../context/LanguageContext";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative border-t border-slate-200 bg-white pt-16 pb-10">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div className="max-w-sm">
            <Logo size={40} />
            <p className="mt-5 text-slate-500 leading-relaxed">{t.footer.tagline}</p>
          </div>
          <div className="flex flex-wrap gap-12">
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-4">{t.footer.product}</p>
              <ul className="space-y-2.5 text-sm text-slate-600">
                <li><a href="/#problem" className="hover:text-u-ink transition-colors">{t.nav.problem}</a></li>
                <li><a href="/#idea" className="hover:text-u-ink transition-colors">{t.nav.idea}</a></li>
                <li><a href="/#proof" className="hover:text-u-ink transition-colors">{t.nav.proof}</a></li>
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-[0.2em] text-slate-400 mb-4">{t.footer.company}</p>
              <ul className="space-y-2.5 text-sm text-slate-600">
                <li><a href="/#vision" className="hover:text-u-ink transition-colors">{t.nav.vision}</a></li>
                <li><a href="/contact" className="hover:text-u-ink transition-colors">{t.nav.contact}</a></li>
                <li><a href="/investor.html" target="_blank" rel="noopener noreferrer" data-testid="footer-link-investors" className="hover:text-u-ink transition-colors">{t.nav.investors}</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-14 pt-6 border-t border-slate-200 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-slate-400">
          <p>© {new Date().getFullYear()} use1ID. {t.footer.rights}</p>
          <BrandText className="text-base" />
        </div>
      </div>
    </footer>
  );
}
